import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import moment from "moment"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css"

const MyRequests = ({ requests, onRequestClick }) => {
    if (requests.length === 0) return null

    return (
        <div className="myreq-section myreq-fade-in">
            <style>{`
                @keyframes myreq-fade-in {
                    0% { opacity: 0; transform: translateY(6px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
                .myreq-fade-in {
                    animation: myreq-fade-in 320ms ease-out both;
                    will-change: opacity, transform;
                }
                @media (prefers-reduced-motion: reduce) {
                    .myreq-fade-in { animation: none; }
                }
            `}</style>
            <div className="apps-category-header">
                <h3 className="md:text-xl text-base font-bold">
                    My Requests this week
                </h3>
            </div>
            <div className="myreq-content mb-4">
                <Swiper
                    className="mt-2 p-1"
                    grabCursor={true}
                    initialSlide={0}
                    centeredSlides={false}
                    slidesPerView="auto"
                    speed={500}
                    spaceBetween={10}
                    pagination={true}
                    slideToClickedSlide={true}
                    modules={[Navigation]}
                    breakpoints={{
                        320: { slidesPerView: 2, spaceBetween: 5 },
                        480: { slidesPerView: 3, spaceBetween: 8 },
                        768: { slidesPerView: 4, spaceBetween: 10 },
                    }}
                >
                    {requests.map((item, i) => (
                        <SwiperSlide
                            key={i}
                            onClick={() => onRequestClick(item)}
                            style={{
                                width: 200,
                                height: 60,
                                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
                                padding: "0px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#fff",
                                position: "relative",
                                borderRadius: "5px",
                                overflow: "hidden",
                                opacity: 1,
                                backgroundPosition: "right bottom",
                                backgroundSize: "45%",
                                backgroundRepeat: "no-repeat",
                            }}
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    backgroundColor: item.status === "Approved" || item.status === "Resolved" ? "#008000" : item.status === "Waiting Approval" ? "#37474F" : "#B22222",
                                    color: "white",
                                    fontSize: "7px",
                                    padding: "2px 14px",
                                    borderTopLeftRadius: "6px",
                                    borderBottomRightRadius: "12px",
                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                                    zIndex: "10",
                                    backgroundImage: "url('https://assets.tokopedia.net/assets-tokopedia-lite/v2/zeus/kratos/b33421a4.svg')",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                }}
                            >
                                {item.status}
                            </div>

                            <div
                                style={{
                                    fontSize: "11px",
                                    fontWeight: "bold",
                                    marginTop: "8px",
                                }}
                            >
                                {item.app_name}
                            </div>
                            <div style={{ fontSize: "10px", color: "#666" }}>{moment(item.created_at).fromNow()}</div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default MyRequests
